import { useState, useEffect, useCallback } from "react";
import { useLocation } from 'react-router';
import VideoBox from "../../casinoComponents/videoBox";
import BetTableTeensin from "../../casinoComponents/betTableTeensin";
import CasinoLastResult from "../../casinoComponents/casinoLastResult";
import CasinoTableLayout from "../../casinoComponents/casinoTableLayout";
import Teen20RefCardsOverlay from "../../casinoComponents/videoBox/overlays/Teen20RefCardsOverlay";
import ResultTeensin from "../resultui/resultTeensin/ResultTeensin";
import TeensinRightSide from "./TeensinRightSide";
import ViewMoreModal from "../../../components/ViewMoreModal";
import { getCasinoGameDetails, getMatchExposure, getMyBets } from "../../../apiservices/CasionApi";
import { extractCasinoGame } from "../../../utils/casinoGame";
import "../../../styles/games/teensin.css";


export default function Teensin() {
    const [gameData, setGameData] = useState([]);
    const [iframeSrc, setiframesrc] = useState("");
    const [exposures, setExposures] = useState({});
    const [myBets, setMyBets] = useState([]);
    const [showViewMoreModal, setShowViewMoreModal] = useState(false);

    const { pathname } = useLocation();

    useEffect(() => {
        const name = extractCasinoGame(pathname);
        setiframesrc(`https://stream-s-43.uhdmovies.online/casino-stream?id=${name}`);

        const fetchGameData = async () => {
            try {
                const response = await getCasinoGameDetails("teensin");
                setGameData(response);
            } catch (err) {
                console.error("Error fetching game data:", err);
            }
        };

        fetchGameData();
        const gameDataInterval = setInterval(fetchGameData, 1500);
        return () => clearInterval(gameDataInterval);
    }, [pathname]);


    const fetchExposure = useCallback(async () => {
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
            const matchId = gameData?.data?.data?.mid?.toString();

            if (userId && matchId) {
                const response = await getMatchExposure(userId, matchId);
                if (response.success && response.data) {
                    const exposureMap = {};
                    response.data.forEach((item) => {
                        exposureMap[item.team_name] = parseFloat(item.exposure_amount) || 0;
                    });
                    setExposures(exposureMap);
                }
            }
        } catch (error) {
            console.error('Error fetching exposure:', error);
        }
    }, [gameData?.data?.data?.mid]);

    const fetchMyBetsData = useCallback(async () => {
        try {
            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const userId = user?.user_id || user?.id || user?.staff_id || user?.owner_id;
            const matchId = gameData?.data?.data?.mid?.toString();

            if (userId && matchId) {
                const response = await getMyBets(userId, matchId);
                if (response.success && response.bets) {
                    const formattedBets = response.bets.map((bet) => ({
                        // My Bets "Gametype" column (casino_bets.game_name, e.g. mogambo)
                        description: bet.description ?? bet.game_name ?? bet.gameName,
                        userName: bet.userName ?? bet.username,
                        placeDate: bet.placeDate ?? bet.created_at,
                        matchedBet: bet.player_name || bet.selection || "",
                        odds: bet.odds || "0",
                        stake: bet.stake || "0",
                        type: bet.type || null,
                        selection: bet.selection || bet.player_name || "",
                        exposer: parseFloat(bet.exposer || bet.exposure_amount || "0") || 0
                    }));
                    setMyBets(formattedBets);
                }
            }
        } catch (error) {
            console.error('Error fetching my bets:', error);
        }
    }, [gameData?.data?.data?.mid]);

    useEffect(() => {
        const matchId = gameData?.data?.data?.mid?.toString();
        if (!matchId) return;

        const timeoutId = setTimeout(() => {
            fetchExposure();
            fetchMyBetsData();
        }, 2000);

        const intervalId = setInterval(() => {
            fetchExposure();
            fetchMyBetsData();
        }, 2000);

        return () => {
            clearTimeout(timeoutId);
            clearInterval(intervalId);
        };
    }, [gameData?.data?.data?.mid, fetchExposure, fetchMyBetsData]);

    // Admin panel places no bets: an odds click only refreshes exposure and My Bets
    const handleBetClick = (value) => {
        if (!value) return;
        fetchExposure();
        fetchMyBetsData();
    };

    const d = gameData?.data?.data;
    const roundId = d?.mid || 0;
    const subData = d?.sub || [];

    // Reference markup: .casino-table.sin-khal has no .game-header — the title and round id sit in the
    // video (.casino-video-title, VideoBox titleNode); the admin panel places no bets (PlaceBet stub
    // rendered nothing), odds clicks only refresh exposure / My Bets via handleBetClick.
    return (
        <CasinoTableLayout
            tableClass="sin-khal"
            rightSide={<TeensinRightSide bets={myBets} onViewMore={() => setShowViewMoreModal(true)} />}
        >
            <>
                <VideoBox
                    iframeSrc={iframeSrc}
                    timerValue={d?.lt}
                    gameType="teensin"
                    titleNode={
                        <div className="casino-video-title">
                            <span className="casino-name">29Card Baccarat</span>{" "}
                            <div className="casino-video-rid">Round ID: {roundId}</div>
                        </div>
                    }
                    cardsOverlay={<Teen20RefCardsOverlay cards={d?.card} showNames={false} />}
                />{" "}
                {d?.mid ? (
                    <div className="casino-detail">
                        <BetTableTeensin
                            data={subData}
                            onBetClick={handleBetClick}
                            exposures={exposures}
                            myBets={myBets}
                        />{" "}
                        {d?.remark ? (
                            <div className="casino-remark mt-3">
                                <div className="remark-icon">
                                    <img src={`${import.meta.env.BASE_URL}assets/img/icons/remark.png`} alt="" />
                                </div>{" "}
                                <marquee>{d.remark}</marquee>
                            </div>
                        ) : null}{" "}
                        <CasinoLastResult
                            gameType="teensin"
                            resultComponent={<ResultTeensin gameType="teensin" />}
                        />
                    </div>
                ) : null}
            </>
            <ViewMoreModal
                show={showViewMoreModal}
                onHide={() => setShowViewMoreModal(false)}
                title="View More"
                sectionKey="teensin"
            />
        </CasinoTableLayout>
    );
}
